// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.test-outerdiv{
    display: inline-block;
    width: 30%;
    height: 100%;
    background-color: #F5F5F5;
}
.test-title{
    font-family: Merriweather Sans;
    font-weight: bold;
    margin: 20px 0px 0px 35px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    width:90%;
}
.test-innerdiv1{
    display: inline-block;
    margin-left: 20px;
}
.test-innerdiv2{
    display: inline-block;
    text-align: center;
    margin: 10px;
    font-weight: bold;
}
.test-innerdiv3{
    margin: auto;
    margin-left: 4.5%;
    overflow-y: auto;
    height: 60vh;
}
.green-icon{
    background-color: green;
    padding-top: 2.5%;
    text-align: center;
    display: inline-block;
    width: 20px;
    height: 20px;
    font-weight: bold;
    color: #fff;
    margin: 5%;
    border-radius:15%;
    cursor: pointer;
}
.grey-icon{
    background-color: grey;
    padding-top: 2.5%;
    text-align: center;
    display: inline-block;
    width: 20px;
    height: 20px;
    font-weight: bold;
    color: #fff;
    margin: 5%;
    border-radius:15%;
}
.blue-icon{
    background-color: #1e90ff;
    padding-top: 2.5%;
    text-align: center;
    display: inline-block;
    width: 20px;
    height: 20px;
    font-weight: bold;
    color: #fff;
    margin: 5%;
    border-radius:15%
}
.green-render{
    border-radius:  5px 20px 5px;
    background-color: green;
    padding-Top: 2.5%;
    text-Align: center;
    display: inline-block;
    width: 45px;
    height: 45px;
    font-Weight: bold;
    color: #fff;
    margin: 5%;
    cursor: pointer;
}
.grey-render{
    border-radius:  5px 20px 5px;
    background-color: grey;
    padding-Top: 2.5%;
    text-Align: center;
    display: inline-block;
    width: 45px;
    height: 45px;
    font-Weight: bold;
    color: #fff;
    margin: 5%;
}
.blue-render{
    border-radius:  5px 20px 5px;
    background-color: #1e90ff;
    padding-Top: 2.5%;
    text-Align: center;
    display: inline-block;
    width: 45px;
    height: 45px;
    font-Weight: bold;
    color: #fff;
    margin: 5%;
    cursor: pointer;
}





`, "",{"version":3,"sources":["webpack://./src/components/modules/learners/quizPage/TakeQuizNav.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,UAAU;IACV,YAAY;IACZ,yBAAyB;AAC7B;AACA;IACI,8BAA8B;IAC9B,iBAAiB;IACjB,yBAAyB;IACzB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;AACb;AACA;IACI,qBAAqB;IACrB,iBAAiB;AACrB;AACA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX,UAAU;IACV,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX,UAAU;IACV,iBAAiB;AACrB;AACA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX,UAAU;IACV;AACJ;AACA;IACI,4BAA4B;IAC5B,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX,UAAU;IACV,eAAe;AACnB;AACA;IACI,4BAA4B;IAC5B,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX,UAAU;AACd;AACA;IACI,4BAA4B;IAC5B,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX,UAAU;IACV,eAAe;AACnB","sourcesContent":[".test-outerdiv{\n    display: inline-block;\n    width: 30%;\n    height: 100%;\n    background-color: #F5F5F5;\n}\n.test-title{\n    font-family: Merriweather Sans;\n    font-weight: bold;\n    margin: 20px 0px 0px 35px;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n    width:90%;\n}\n.test-innerdiv1{\n    display: inline-block;\n    margin-left: 20px;\n}\n.test-innerdiv2{\n    display: inline-block;\n    text-align: center;\n    margin: 10px;\n    font-weight: bold;\n}\n.test-innerdiv3{\n    margin: auto;\n    margin-left: 4.5%;\n    overflow-y: auto;\n    height: 60vh;\n}\n.green-icon{\n    background-color: green;\n    padding-top: 2.5%;\n    text-align: center;\n    display: inline-block;\n    width: 20px;\n    height: 20px;\n    font-weight: bold;\n    color: #fff;\n    margin: 5%;\n    border-radius:15%;\n    cursor: pointer;\n}\n.grey-icon{\n    background-color: grey;\n    padding-top: 2.5%;\n    text-align: center;\n    display: inline-block;\n    width: 20px;\n    height: 20px;\n    font-weight: bold;\n    color: #fff;\n    margin: 5%;\n    border-radius:15%;\n}\n.blue-icon{\n    background-color: #1e90ff;\n    padding-top: 2.5%;\n    text-align: center;\n    display: inline-block;\n    width: 20px;\n    height: 20px;\n    font-weight: bold;\n    color: #fff;\n    margin: 5%;\n    border-radius:15%\n}\n.green-render{\n    border-radius:  5px 20px 5px;\n    background-color: green;\n    padding-Top: 2.5%;\n    text-Align: center;\n    display: inline-block;\n    width: 45px;\n    height: 45px;\n    font-Weight: bold;\n    color: #fff;\n    margin: 5%;\n    cursor: pointer;\n}\n.grey-render{\n    border-radius:  5px 20px 5px;\n    background-color: grey;\n    padding-Top: 2.5%;\n    text-Align: center;\n    display: inline-block;\n    width: 45px;\n    height: 45px;\n    font-Weight: bold;\n    color: #fff;\n    margin: 5%;\n}\n.blue-render{\n    border-radius:  5px 20px 5px;\n    background-color: #1e90ff;\n    padding-Top: 2.5%;\n    text-Align: center;\n    display: inline-block;\n    width: 45px;\n    height: 45px;\n    font-Weight: bold;\n    color: #fff;\n    margin: 5%;\n    cursor: pointer;\n}\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
